import { useApi } from './useApi';
import { url } from '../../utils/confserveur';
export const useQuestion = (classes, refreshData, etablissementId) => {
  let urlfetch = classes ? `${url}questions/${classes}` : url+'questions/';
  if (etablissementId) {
    urlfetch += `${classes ? '&' : '?'}etablissement=${etablissementId}`;
  }
  return useApi(urlfetch, [], refreshData);
};